<div class="col-3 my-4">
	<div class="input-group inline-group">
		<fieldset [disabled]="editable">
			<div class="input-group-prepend">
				<button mat-raised-button (click)="setDate(-1)">
					<i class="fa fa-arrow-left"></i>
				</button>
			</div>
		</fieldset>
		<input
			type="month"
			class="form-control me-2 ms-2"
			name="selectedMonth"
			id="selectedMonth"
			[(ngModel)]="selectedMonth"
			[disabled]="true"
		/>
		<fieldset [disabled]="editable">
			<div class="input-group-append">
				<button mat-raised-button (click)="setDate(+1)">
					<i class="fa fa-arrow-right"></i>
				</button>
			</div>
		</fieldset>
	</div>
</div>
